
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/profile",
      function () {
        return require("private-next-pages/dashboard/profile.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/profile"])
      });
    }
  